import { Anima } from "kido/anima";
import { queryAll } from "kido/utils";

import { BasePage } from "@app/primitives/base-page";

export class AboutPage extends BasePage {
  private _container: HTMLElement | null = null;

  async init(container: Element | null): Promise<void> {
    if (!container) return;
    await super.init(container);
    this._container = container as HTMLElement;

    // Set all hidden elements to visible but transparent for fade-in
    const fadeTargets = queryAll(
      container as HTMLElement,
      ".ab-intro_b, .ab-services_b, .ab-hop_b, .ab-nb_b, .ab-careers_b, .ab-tagline, .ab-sticker, .ab-label, .ab-person_t, .ab-office, .ab-dot, .ab-social_arrow"
    ) as HTMLElement[];
    for (const el of fadeTargets) {
      el.style.visibility = "visible";
      el.style.opacity = "0";
    }
  }

  async in(): Promise<void> {
    if (!this._container) return;

    const fadeTargets = queryAll(
      this._container,
      ".ab-intro_b, .ab-services_b, .ab-hop_b, .ab-nb_b, .ab-careers_b, .ab-tagline, .ab-sticker, .ab-label, .ab-person_t, .ab-office, .ab-dot, .ab-social_arrow"
    ) as HTMLElement[];

    for (const el of fadeTargets) {
      new Anima({
        el,
        p: { o: [0, 1, ""] },
        d: 1000,
        e: "oQ",
      }).play();
    }
  }

  async out(): Promise<void> {
    this._container = null;
  }
}
